<template>
<!-- 
    * Copyright: T-Systems México S.A. de C.V.
    * Descripción: Vista galeria de sala de juntas, permite consultar, crear, editar y eliminar una imagen ligada a una sala de juntas 
    * Autor: 
    * F.Creación: 
  -->
  <layout :title="$t('moduleTitle')">
    <!-- Contenido -->
    <template v-slot:content>
      <router-link
        class="white--text"
        v-if="$routerHistory.hasPrevious()"
        :to="{ path: $routerHistory.previous().path }"
      >
        <v-btn class="mb-2" tile color="primary">
          <v-icon left>mdi-chevron-left</v-icon>
          {{$t('lblback')}}
        </v-btn>
      </router-link>
      
      <v-dialog persistent v-model="addDialogFlag" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgUploadTitle")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-form ref="addForm" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-file-input
                      show-size
                      accept=".png"
                      :hint="$t('lblFileName')"
                      persistent-hint
                      prepend-icon
                      v-model="files"
                      append-icon="mdi-folder-search"
                      v-on:change="handleFileUpload"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-radio-group v-model="currentPhoto.resourceTypeId" :mandatory="false">
                      <v-radio :label="$t('Foto')" :value="2"></v-radio>
                      <v-radio :label="$t('Mapa')" :value="9"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12" center v-if="progress > 0">
                    <v-progress-linear v-model="progress" height="25" reactive>
                      <strong>{{ progress }}%</strong>
                    </v-progress-linear>
                  </v-col>
                  <v-col cols="12">
                    <p class="caption error--text" v-html="errorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeAddDialog()">{{$t("btnCancel")}}</v-btn>
            <v-btn text @click.stop="doAddDialog()" color="primary">{{$t("btnNew")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="uploadDialogFlag" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgUploadTitle")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-form ref="uploadForm" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-file-input
                      show-size
                      accept=".png"
                      :hint="$t('lblFileName')"
                      persistent-hint
                      prepend-icon
                      v-model="files"
                      append-icon="mdi-folder-search"
                      v-on:change="handleFileUpload"
                    />
                  </v-col>
                  <v-col cols="12" center>
                    <v-progress-linear v-if="progress > 0" v-model="progress" height="25" reactive>
                      <strong>{{ progress }}%</strong>
                    </v-progress-linear>
                  </v-col>
                  <v-col cols="12">
                    <p class="caption error--text" v-html="errorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeUploadDialog()">{{$t("btnCancel")}}</v-btn>
            <v-btn text @click.stop="doUploadDialog()" color="primary">{{$t("btnUpdate")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="deleteDialogFlag" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgDeleteTitle")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <p class="mt-10" v-html="$t('dlgDeleteText')"></p>
                </v-col>
                <v-col cols="12">
                  <p class="caption error--text" v-html="errorMessage"></p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeDeleteMapDialog()">{{$t("btnCancel")}}</v-btn>
            <v-btn text @click.stop="doDeleteMapDialog()" color="primary">{{$t("btnDelete")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-container fluid>
        <v-row></v-row>
        <v-data-iterator
          :loading="isLoading"
          :items="filteredPhotos"
          :items-per-page.sync="itemsPerPage"
          hide-default-footer
        >
          <template v-slot:no-data>
            <v-container fluid white></v-container>
          </template>
          <template v-slot:loading>
            <v-container fluid white>Obteniendo datos</v-container>
          </template>

          <template v-slot:header>
            <v-toolbar color="primary" flat>
              <v-toolbar-title class="white--text">{{$t('moduleTitle', {name: nombre})}}</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>

              <v-menu bottom class="ml-4">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" tile color="primary" class="white--text mr-2">
                    {{ selectedFilter }}
                    <v-icon rigth dark>mdi-filter-menu-outline</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item v-for="(item, i) in filters" :key="i" @click="selectFilter(item)">
                    <v-list-item-title v-html="$t(`aFilter[${item.value}]`)"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-btn
                outlined
                color="white"
                @click.stop="showAddDialog()"
                tile
                :disabled="isAddButtonEnabled"
              >{{$t('btnNew')}}</v-btn>
            </v-toolbar>
          </template>

          <template v-slot:default="props">
            <v-row>
              <v-col v-for="item in props.items" :key="item.name" cols="12" sm="6" md="4" lg="3">
                <v-card class="mx-auto" max-width="400">
                  <v-img class="white--text align-end" height="200px" :src="item.url"></v-img>

                  <v-card-actions>
                    <v-icon color="primary" v-show="item.resourceTypeId === 9">mdi-map-legend</v-icon>
                    <v-icon color="primary" v-show="item.resourceTypeId === 2">mdi-image</v-icon>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="showDeleteDialog(item)" icon class="ml-2" tile>
                      <v-icon fab>mdi mdi-delete</v-icon>
                    </v-btn>
                    <v-btn @click.stop="showUploadDialog(item)" icon class="ml-2" tile>
                      <v-icon>mdi mdi-upload</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-container>
    </template>
  </layout>
</template>

<script>
import Layout from "@/components/Layouts/company";
import i18nMessages from "./i18n.messages";
// Utilities
import { mapGetters } from "vuex";
import _ from "lodash";
import uuid from "uuid4";

let DEFAULT_PHOTO_MODEL = { id: 0, resourceTypeId: 2 };
let BASE_URL_FOR_PHOTOS = "content/meeting-rooms/photos/";
let DEFAULT_FILE_MODEL = { isValid: false, contentData: null };
let DEFAULT_FILTER = { value: 0 };

export default {
  components: {
    layout: Layout
  },
  created() {
    this.$i18n.locale = this.locale;
    this.loadData();
  },
  beforeDestroy() {},
  i18n: i18nMessages,
  data: function() {
    return {
      // Se utiliza para conocer el porcentage
      // del proceso de UPLOAD de un archivo
      progress: 0,
      // Se utilizan como banderas (FLAG) para
      // los cuadros de dialogo
      nombre: this.$route.params.nombre,
      addDialogFlag: false,
      deleteDialogFlag: false,
      uploadDialogFlag: false,
      // Se utilizan para controlar el componente
      // INPUT FILE, que sirve para seleccionar y cargar
      // archivos
      files: [],
      // Archivo seleccionado
      currentFile: DEFAULT_FILE_MODEL,
      //Recurso (FORO) seleccionada
      currentPhoto: DEFAULT_PHOTO_MODEL,
      // Mensaje de error, si existe un mensaje de error
      // se almacena en está variable.
      errorMessage: "",
      //
      currentFilter: DEFAULT_FILTER,
      //Filtros
      filters: [
        { value: 0 },
        { value: 1, resourceTypeId: 2 },
        { value: 2, resourceTypeId: 9 }
      ],
      resourcesFilter: 0,
      photos: [],
      itemsPerPage: 10,
      
    };
  },
  mounted: () => {},
  computed: {
    ...mapGetters(["isLoading"]),
    locale() {
      return this.$store.getters["locale"];
    },
    selectedFilter() {
      // // eslint-disable-next-line no-debugger
      // debugger
      let value = this.currentFilter != null ? this.currentFilter : 0;
      let text = this.$i18n.messages[this.locale].aFilter[value];
      //** console.log(text);
      return text;
    },
    isAddButtonEnabled() {
      // Solo se permiten un total de 10 fotos como máximo.
      // Por lo que el boton agregar imagen se deshabilitará
      // si la sala ya tiene asignada 8 o mas fotos.

      //** console.log(this.photos);
      return this.photos && this.photos.length >= 8;
    },
    filteredPhotos() {
      if (this.photos) {
        let photos = this.photos
          .filter(photo => {
            return (
              this.currentFilter.value === 0 ||
              photo.resourceTypeId === this.currentFilter.resourceTypeId
            );
          })
          .sort((a, b) => {
            return b.resourceTypeId - a.resourceTypeId;
          });
        return photos;
      } else {
        return [];
      }
    }
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
    }
  },
  methods: {
    loadData() {
      let payload = {
        itemId: this.$route.params.itemId
      };

      this.$GET("/api/items/{{itemId}}/resources", payload)
        .then(photos => {
          //** console.log("PHOTOS");
          // console.log(JSON.stringify(photos));

          //Ingnoramos todos los recursos que no sean de tipo 2 ó 9
          this.photos = photos.filter(photo => {
            let value =
              photo.resourceTypeId === 2 || photo.resourceTypeId === 9;
            if (!value) {
              //** console.log("Descartando recurso:" + photo.content);
            }
            // Se agrega la propieda URL para hacerla reactiva
            photo.url = "";
            return value;
            
          });

          photos.forEach(photo => {
            this.$Storage
              .get(`content/${photo.content}`)
              .then(url => {
                //** console.log(url);
                photo.url = url;
              })
              .catch(() => 
              {
                // console.log(e)
              })
              .finally(() => {});
          });
          //** console.log("PHOTOS with URL ======================");
          //** console.log(JSON.stringify(photos));
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          //** console.log(e);
        });
    },

    selectFilter(value) {
      //** console.log("selectFilter:");
      //** console.log(value);
      this.currentFilter = value;
    },

    // New photo
    showAddDialog() {
      this.currentPhoto = DEFAULT_PHOTO_MODEL;
      this.addDialogFlag = true;
      this.progress = 0;
    },
    closeAddDialog() {
      this.addDialogFlag = false;
      this.currentPhoto = DEFAULT_PHOTO_MODEL;
      this.progress = 0;
      this.$refs.addForm.reset();
    },
    doAddDialog() {
      this.errorMessage = "";

      if (this.currentFile.isValid) {
        this.doUploadPhoto(path => {

          
          console.log("=================== PATH ======================")
          console.log(path)
          console.log("=================== ++++ ======================")

          this.currentPhoto.content = path.replace("content/", "");
          let payload = {
            params: {
              itemId: this.$route.params.itemId
            },
            data: this.currentPhoto
          };

          //** console.log("payload");
          //** console.log(payload);
          return this.$POST("/api/items/{{itemId}}/resources", payload)
            .then(() => {
              //** console.log("response");
              //** console.log(response);
              this.closeAddDialog();
              this.loadData();
            })
            .catch(() => {
              // En caso de error presentar un mensaje
              // al usuario
              //** console.log("error");
              //** console.log(e);
              this.errorMessage = "Ocurrió un error al cargar la foto";
            })
            .finally(() => {});
        });
      } else {
        this.errorMessage = "El archivo no es válido";
      }
    },

    // UPLOAD photo
    showUploadDialog(photo) {
      this.currentPhoto = _.clone(photo);
      this.uploadDialogFlag = true;
    },
    closeUploadDialog() {
      this.uploadDialogFlag = false;
      this.currentPhoto = DEFAULT_PHOTO_MODEL;
      this.progress = 0;
      this.$refs.uploadForm.reset();
    },
    doUploadDialog() {
      this.errorMessage = "";

      if (this.currentFile.isValid) {

        this.doUploadPhoto(path => {

          console.log("=================== PATH ======================")
          console.log(path)
          console.log("=================== ++++ ======================")

          this.currentPhoto.content = path.replace("content/", "");

          let payload = {
            params: {
              itemId: this.$route.params.itemId,
              resourceId: this.currentPhoto.id
            },
            data: this.currentPhoto
          };

          return this.$PUT(
            "/api/items/{{itemId}}/resources/{{resourceId}}",
            payload
          )
            .then(() => {
              //** console.log(response);
              this.closeUploadDialog();
              this.loadData();
            })
            .catch(() => {
              // En caso de error presentar un mensaje
              // al usuario
              //** console.log(e);
              this.errorMessage = "Ocurrió un error al actualizar el mapa";
            })
            .finally(() => {});
        });
      } else {
        this.errorMessage = "El archivo no es válido";
      }
    },

    // DELETE Map
    showDeleteDialog(photo) {
      this.currentPhoto = _.clone(photo);
      this.deleteDialogFlag = true;
    },
    closeDeleteDialog() {
      this.currentPhoto = DEFAULT_PHOTO_MODEL;
      this.deleteDialogFlag = false;
    },
    doDeleteMapDialog() {
      //PAYLOAD parra el DELETE
      let payload = {
        params: {
          itemId: this.$route.params.itemId,
          resourceId: this.currentPhoto.id
        },
        data: this.currentPhoto
      };
      // Limpiamos el mensaje de error, en caso de tener un
      // error previo
      this.errorMessage = "";
      this.$DELETE("/api/items/{{itemId}}/resources/{{resourceId}}", payload)
        .then(() => {
          this.closeDeleteDialog();
          this.loadData();
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          //** console.log(e);
          this.errorMessage = "Ocurrió un error al eliminar la foto";
        })
        .finally(() => {});
    },

    // Manejador del archivo
    handleFileUpload(currentFile) {
      let self = this;

      if (!currentFile || currentFile.length === 0) {
        this.currentFile = null;
      } else if (currentFile.type != "image/png") {
        self.errorMessage = self.$t("lblFileTypeError");
      } else {
        self.$store.dispatch("initLoader");
        self.currentFile = currentFile;
        self.currentFile.isValid = false;
        self.currentFile.contentData = null;
        self.errorMessage = "";

        let reader = new FileReader();
        reader.onload = function(e) {
          try {
            let data = new Uint8Array(e.target.result);
            self.currentFile.contentData = data;
            self.currentFile.isValid = true;
          } catch (error) {
            window.//** console.log(error);
            self.errorMessage = error.message;
          } finally {
            self.$store.dispatch("stopLoader");
          }
        };
        reader.readAsArrayBuffer(self.currentFile);
      }
    },
    // Carga el archivo en el bucket S3
    async doUploadPhoto(callback) {
      this.totalSteps = 0;
      this.completedSteps = 0;

      if (this.currentFile.isValid && this.currentFile.contentData) {
        let path = `${BASE_URL_FOR_PHOTOS}${uuid()}.png`;
        //** console.log("Content id:" + path);
        return this.$Storage.put(
          path,
          this.currentFile.contentData,
          this.uploadProgressCallback,
          () => {
            return callback(path);
          }
        );
      } else {
        throw new Error("Invalid file");
      }
    },
    // Progess callback
    uploadProgressCallback(progress) {
      this.progress = Math.ceil((progress.loaded / progress.total) * 100);
      /* console.log(
        `Uploaded: ${progress.loaded}/${progress.total}  ${this.progress}%`
      );*/
    }
  }
};
</script>